// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1uQVQ","cell":"ColumnAccessor_cell__27wTi","firstCellAccent":"ColumnAccessor_firstCellAccent__2UBZ9"};